/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

/**
 * Provides a utility which returns the application version based on the version
 * provided to process.env at build time, defaulting to process.env.VERSION, and
 * falling back to process.env.NEXT_PUBLIC_APP_VERSION.
 *
 * ```typescript
 *
 *    import {getVersion} from '@ion/core/src/environment/version';
 *
 *    const version = getVersion();
 *
 * ```
 */
export const getVersion = (): string => {
  if (process?.env) {
    const {VERSION, NEXT_PUBLIC_APP_VERSION} = process.env;
    return VERSION || NEXT_PUBLIC_APP_VERSION;
  }
};
export default getVersion;
